import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotComponent } from './chatbot.component';

@NgModule({
  declarations: [ChatbotComponent],
  exports: [ChatbotComponent],
  imports: [CommonModule]
})
export class CmxChatbotModule { }
